/**
 * =============================================================================
 * Loading Screen Component
 * =============================================================================
 *
 * Full-screen loading indicator.
 * Shown during Keycloak initialization and route transitions.
 */

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {/* Spinner */}
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary-600 border-t-transparent mb-4" />

        {/* Text */}
        <p className="text-gray-600 font-medium">Loading...</p>
      </div>
    </div>
  )
}

export default LoadingScreen
